import { Component, OnInit, Input } from '@angular/core';
import { SessionService } from '../../../services/session/session.service';
import { AuthService } from '../../../../auth/services/auth/auth.service';
import { MUser } from '@argalis-apps/models';
@Component({
  selector: 'ags-session-rapport-intervenant',
  templateUrl: './session-rapport-intervenant.component.html',
  styleUrls: ['./session-rapport-intervenant.component.scss']
})
export class SessionRapportIntervenantComponent implements OnInit {
  public idSession;
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = Number(value);
    }
  }
  public rapportIntervevant = [];
  private idIntervenant: number;
  private bOst: boolean;
  public evaluation = [];
  // TODO modif idsession et idintervenant
  userConnected: MUser.CUser;
  constructor(private sessionService: SessionService, private authService: AuthService) {
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else {
        this.userConnected = Object.assign({}, user);
      }
    });
  }
  ngOnInit() {
    // TODO modifier getSessionPlanningExtranet(idIntervenant, bOrganismeSoustraitant, idSession);
    this.initData();
    this.rapportIntervevant = [
      {
        idIntervenant: this.idIntervenant,
        bOrganismeSoustraitant: this.bOst,
        idSession: this.idSession,
        code: 'CONDITIONS',
        info_outline: 'Ajoutez un commentaire à propos de la salle, du mobilier, du matériel.',
        titre: 'CONDITIONS MATERIELLES',
        commentaire: '',
        note: ''
      },
      {
        idIntervenant: this.idIntervenant,
        bOrganismeSoustraitant: this.bOst,
        idSession: this.idSession,
        code: 'ORGANISATION',
        info_outline:
          ' Ajoutez un commentaire à propos des horaires, de la durée, du rythme, de la période intersession.',
        titre: 'ORGANISATION TEMPORELLE',
        commentaire: '',
        note: ''
      },
      {
        idIntervenant: this.idIntervenant,
        bOrganismeSoustraitant: this.bOst,
        idSession: this.idSession,
        code: 'EFFECTIF',
        info_outline: "Ajoutez un commentaire à propos du nombre de participants, de l'homogénéité de niveau.",
        titre: 'EFFECTIF',
        commentaire: '',
        note: ''
      },
      {
        idIntervenant: this.idIntervenant,
        bOrganismeSoustraitant: this.bOst,
        idSession: this.idSession,
        code: 'DYNAMIQUE',
        info_outline:
          ' Ajoutez un commentaire à propos de la motivation des participants, de leur implication, leur savoir être.',
        titre: 'DYNAMIQUE DU GROUPE',
        commentaire: '',
        note: ''
      }
    ];
  }
  initData() {
    this.idIntervenant = this.userConnected.userInfo.id;
    this.bOst = this.userConnected.userInfo.b_ost;
    this.sessionService.getSessionPlanningExtranet(this.idIntervenant, this.bOst || false, this.idSession).subscribe(
      result => {
        this.evaluation = result;
        this.rapportIntervevant.map(elm => this.getCom(elm.code, elm));
      },
      () => {}
    );
  }
  getCom(code: string, elm) {
    switch (code) {
      case 'ORGANISATION':
        const found = this.evaluation.find(el => (el || ({} as any)).code === 'ORGANISATION');
        elm.commentaire = ((found || ({} as any)).commentaire || '').toString();
        elm.note = Number((found || ({} as any)).note || '');
        return elm;
      case 'CONDITIONS':
        const found1 = this.evaluation.find(el => (el || ({} as any)).code === 'CONDITIONS');
        elm.commentaire = ((found1 || ({} as any)).commentaire || '').toString();
        elm.note = Number((found1 || ({} as any)).note || '');
        return elm;
      case 'EFFECTIF':
        const found2 = this.evaluation.find(el => (el || ({} as any)).code === 'EFFECTIF');
        elm.commentaire = ((found2 || ({} as any)).commentaire || '').toString();
        elm.note = Number((found2 || ({} as any)).note || '');
        return elm;
      case 'DYNAMIQUE':
        const found3 = this.evaluation.find(el => (el || ({} as any)).code === 'DYNAMIQUE');
        elm.commentaire = ((found3 || ({} as any)).commentaire || '').toString();
        elm.note = Number((found3 || ({} as any)).note || '');
        return elm;
    }
  }
  // TODO modif idsession et idintervenant
  valider() {
    this.sessionService.updateSessionIntervenantSatisfaction(this.rapportIntervevant).subscribe(() => {
      this.initData();
    });
  }
  toggleRapport(i, rapport) {
    const newRapport = Object.assign({}, rapport);
    newRapport.note = Number(i);
    this.rapportIntervevant = this.rapportIntervevant.map(oldRapport => {
      if (oldRapport.code === newRapport.code) {
        oldRapport = Object.assign({}, newRapport);
      }
      return oldRapport;
    });
  }
}
